import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { PropsWithChildren } from 'react'
import { esES } from '@mui/material/locale'
import { esES as datePickerEs } from '@mui/x-date-pickers/locales'
import { colors } from '@/core/themeProvider/colors.ts'

declare module '@mui/material/styles' {
  interface Theme {
    extraColors: {
      border: string
      bodyBackground: string
      secondaryLoading: string
      blendingGrey: string
      backgroundGrey: string
    }
  }

  // allow configuration using `createTheme()`
  interface ThemeOptions {
    extraColors?: {
      border?: string
      bodyBackground: string
      secondaryLoading: string
      blendingGrey: string
      backgroundGrey: string
    }
  }
}

const theme = createTheme(
  {
    palette: {
      primary: {
        main: colors.primary
      },
      secondary: {
        main: colors.secondary
      }
    },
    extraColors: {
      border: '#e0e0e0',
      bodyBackground: '#F3F3F9',
      secondaryLoading: '#c6c6c6',
      blendingGrey: '#878A99',
      backgroundGrey: '#CED4DA'
    }
  },
  esES,
  datePickerEs
)

const ThemeProvider = ({ children }: PropsWithChildren) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
}

export default ThemeProvider
